/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/PerformanceIndicatorDataReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./PerformanceIndicatorDataReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.GoalMetricReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.PerformanceIndicatorDataReport);
  }
}(this, function(ApiClient, CorporateStructureLink, PerformanceIndicatorDataReport) {
  'use strict';




  /**
   * The GoalMetricReport model module.
   * @module model/GoalMetricReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>GoalMetricReport</code>.
   * @alias module:model/GoalMetricReport
   * @class
   */
  var exports = function() {
    var _this = this;





























  };

  /**
   * Constructs a <code>GoalMetricReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalMetricReport} obj Optional instance to populate.
   * @return {module:model/GoalMetricReport} The populated <code>GoalMetricReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('PerformancePerspectiveGroupID')) {
        obj['PerformancePerspectiveGroupID'] = ApiClient.convertToType(data['PerformancePerspectiveGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('Expired')) {
        obj['Expired'] = ApiClient.convertToType(data['Expired'], 'Boolean');
      }
      if (data.hasOwnProperty('CanUserEditMetric')) {
        obj['CanUserEditMetric'] = ApiClient.convertToType(data['CanUserEditMetric'], 'Boolean');
      }
      if (data.hasOwnProperty('Data')) {
        obj['Data'] = ApiClient.convertToType(data['Data'], [PerformanceIndicatorDataReport]);
      }
      if (data.hasOwnProperty('LastActual')) {
        obj['LastActual'] = ApiClient.convertToType(data['LastActual'], 'Number');
      }
      if (data.hasOwnProperty('LatestActualUpdateDate')) {
        obj['LatestActualUpdateDate'] = ApiClient.convertToType(data['LatestActualUpdateDate'], 'Date');
      }
      if (data.hasOwnProperty('GoalID')) {
        obj['GoalID'] = ApiClient.convertToType(data['GoalID'], 'Integer');
      }
      if (data.hasOwnProperty('ProgramID')) {
        obj['ProgramID'] = ApiClient.convertToType(data['ProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StartValue')) {
        obj['StartValue'] = ApiClient.convertToType(data['StartValue'], 'Number');
      }
      if (data.hasOwnProperty('MilestoneID')) {
        obj['MilestoneID'] = ApiClient.convertToType(data['MilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('GoalValue')) {
        obj['GoalValue'] = ApiClient.convertToType(data['GoalValue'], 'Number');
      }
      if (data.hasOwnProperty('GoalValueTypeID')) {
        obj['GoalValueTypeID'] = ApiClient.convertToType(data['GoalValueTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('InputManually')) {
        obj['InputManually'] = ApiClient.convertToType(data['InputManually'], 'Boolean');
      }
      if (data.hasOwnProperty('SheetGoogleConfigurationID')) {
        obj['SheetGoogleConfigurationID'] = ApiClient.convertToType(data['SheetGoogleConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyID')) {
        obj['StrategyID'] = ApiClient.convertToType(data['StrategyID'], 'Integer');
      }
      if (data.hasOwnProperty('ValueSourceID')) {
        obj['ValueSourceID'] = ApiClient.convertToType(data['ValueSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('AggregateGoal')) {
        obj['AggregateGoal'] = ApiClient.convertToType(data['AggregateGoal'], 'Boolean');
      }
      if (data.hasOwnProperty('UseIncreasingDirection')) {
        obj['UseIncreasingDirection'] = ApiClient.convertToType(data['UseIncreasingDirection'], 'Boolean');
      }
      if (data.hasOwnProperty('ValueDependencyRuleID')) {
        obj['ValueDependencyRuleID'] = ApiClient.convertToType(data['ValueDependencyRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} PerformancePerspectiveGroupID
   */
  exports.prototype['PerformancePerspectiveGroupID'] = undefined;
  /**
   * @member {Boolean} Expired
   * @default false
   */
  exports.prototype['Expired'] = false;
  /**
   * @member {Boolean} CanUserEditMetric
   * @default false
   */
  exports.prototype['CanUserEditMetric'] = false;
  /**
   * @member {Array.<module:model/PerformanceIndicatorDataReport>} Data
   */
  exports.prototype['Data'] = undefined;
  /**
   * @member {Number} LastActual
   * @default 0.0
   */
  exports.prototype['LastActual'] = 0.0;
  /**
   * @member {Date} LatestActualUpdateDate
   */
  exports.prototype['LatestActualUpdateDate'] = undefined;
  /**
   * @member {Integer} GoalID
   */
  exports.prototype['GoalID'] = undefined;
  /**
   * @member {Integer} ProgramID
   */
  exports.prototype['ProgramID'] = undefined;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} PeriodTypeID
   * @default 0
   */
  exports.prototype['PeriodTypeID'] = 0;
  /**
   * @member {Number} StartValue
   */
  exports.prototype['StartValue'] = undefined;
  /**
   * @member {Integer} MilestoneID
   */
  exports.prototype['MilestoneID'] = undefined;
  /**
   * @member {Number} GoalValue
   */
  exports.prototype['GoalValue'] = undefined;
  /**
   * @member {Integer} GoalValueTypeID
   * @default 0
   */
  exports.prototype['GoalValueTypeID'] = 0;
  /**
   * @member {Boolean} InputManually
   * @default false
   */
  exports.prototype['InputManually'] = false;
  /**
   * @member {Integer} SheetGoogleConfigurationID
   */
  exports.prototype['SheetGoogleConfigurationID'] = undefined;
  /**
   * @member {Integer} OwnerID
   * @default 0
   */
  exports.prototype['OwnerID'] = 0;
  /**
   * @member {Integer} StrategyID
   */
  exports.prototype['StrategyID'] = undefined;
  /**
   * @member {Integer} ValueSourceID
   * @default 0
   */
  exports.prototype['ValueSourceID'] = 0;
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Boolean} AggregateGoal
   * @default false
   */
  exports.prototype['AggregateGoal'] = false;
  /**
   * @member {Boolean} UseIncreasingDirection
   * @default false
   */
  exports.prototype['UseIncreasingDirection'] = false;
  /**
   * @member {Integer} ValueDependencyRuleID
   */
  exports.prototype['ValueDependencyRuleID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


